import { useState } from "react";
import {
  ICitationFormInput,
  IReturnCitationPublication,
  IReturnCitationContributors,
  IReturnArticleContributors,
  ICitationAuthor,
} from "../CitationAction.interface";
import CitationEditFormPublication from "./CitationEditFormPublication";
import CitationEditFormFooter from "./CitationEditFormFooter";
import {
  formContainerCss,
  titleCss,
  wrapperCss,
} from "./CitationEditForm.style";
import CitationEditFormContributors from "./CitationEditFormContributors";
import CitationEditFormArticle from "./CitationEditFormArticle";

interface CitationEditFormProps {
  setShowEditForm: (showEditForm: boolean) => void;
  handleEditChanges: (data: ICitationFormInput) => void;
  citationData: ICitationFormInput;
}

const CitationEditForm = ({
  setShowEditForm,
  handleEditChanges,
  citationData: {
    authors,
    websiteTitle,
    url,
    title,
    datePublished: publishedDate,
  },
}: CitationEditFormProps) => {
  const date = new Date();
  const isoDate = date.toISOString();

  const [touched, setTouched] = useState<boolean>(false);
  const [titleValue, setTitleValue] = useState<string>(title || "");
  const [authorsValue, setAuthorsValue] = useState<ICitationAuthor[]>(
    authors || [],
  );
  const [websiteTitleValue, setWebsiteTitleValue] = useState<string>(
    websiteTitle || "",
  );
  const [urlValue, setUrlValue] = useState<string>(url || "");
  const [datePublishedValue, setDatePublishedValue] = useState<string>(isoDate);
  const [dateAccessedValue, setDateAccessedValue] = useState<string>(isoDate);

  const handleArticleReturn = (data: IReturnArticleContributors) => {
    if (data.title !== titleValue) setTitleValue(data.title);
  };
  const handlePublicationReturn = (data: IReturnCitationPublication) => {
    if (data.datePublished !== datePublishedValue)
      setDatePublishedValue(data.datePublished);
    if (data.dateAccessed !== dateAccessedValue)
      setDateAccessedValue(data.dateAccessed);
    if (data.websiteTitle !== websiteTitleValue)
      setWebsiteTitleValue(data.websiteTitle);
    if (data.url !== urlValue) setUrlValue(data.url);
  };

  const handleContributorsReturn = (data: IReturnCitationContributors) => {
    if (JSON.stringify(data.authors) !== JSON.stringify(authorsValue))
      setAuthorsValue(data.authors);
  };

  const handleSubmit = () => {
    const hasEmptyName = authorsValue.some(
      (author) => author.firstName === "" || author.lastName === "",
    );
    setTouched(true);
    if (
      titleValue.length !== 0 &&
      websiteTitleValue.length !== 0 &&
      urlValue.length !== 0 &&
      urlValue.length !== 0 &&
      datePublishedValue &&
      !hasEmptyName
    ) {
      setTouched(false);
      setShowEditForm(false);
      handleEditChanges({
        authors: authorsValue,
        title: titleValue,
        websiteTitle: websiteTitleValue,
        url: urlValue,
        datePublished: datePublishedValue,
        dateAccessed: dateAccessedValue,
      } as ICitationFormInput);
    }
  };

  return (
    <form css={wrapperCss}>
      <div css={formContainerCss}>
        <h3 css={titleCss}>Edit citation information</h3>
        <CitationEditFormArticle
          title={titleValue}
          touched={touched}
          handleArticleReturn={handleArticleReturn}
        />
        <CitationEditFormContributors
          authors={authors}
          touched={touched}
          handleContributorsReturn={handleContributorsReturn}
        />
        <CitationEditFormPublication
          publishedDate={publishedDate}
          websiteTitle={websiteTitle}
          url={url}
          touched={touched}
          handlePublicationReturn={handlePublicationReturn}
        />
      </div>
      <CitationEditFormFooter
        setShowEditForm={setShowEditForm}
        handleSubmit={handleSubmit}
      />
    </form>
  );
};

export default CitationEditForm;
